/*Borrowed from: https://medium.com/better-programming/angular-how-keep-user-from-lost-his-data-by-accidentally-leaving-the-page-before-submit-4eeb74420f0d */
import { HostListener, Injectable, inject } from "@angular/core";
import { CanDeactivateFn } from "@angular/router";
import { Observable } from "rxjs";

export abstract class ComponentCanDeactivate {

    abstract canDeactivate(): boolean | Observable<boolean> | Promise<boolean>;

   
    //unloadNotification($event: any) {
    //    if (!this.canDeactivate()) {
    //        $event.returnValue = true;
    //    }
    //}
}

@Injectable({
    providedIn: 'root'
})
class CanDeactivateGuard {

    canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> | Promise<boolean> {        
        return component.canDeactivate ? component.canDeactivate() : true;        
    }
}

export const DeactivateGuard: CanDeactivateFn<ComponentCanDeactivate> = (component: ComponentCanDeactivate) => {
    return inject(CanDeactivateGuard).canDeactivate(component);
}
